exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.scroll[data-v-d9862b38] {\n    height: 500px;\n    overflow: scroll;\n    overflow-x: hidden;\n    overflow-y: auto;\n}\n.scroll[data-v-d9862b38]::-webkit-scrollbar {\n    width: 6px;\n}\n.scroll[data-v-d9862b38]::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n    border-radius: 10px;\n}\n.scroll[data-v-d9862b38]::-webkit-scrollbar-thumb {\n    border-radius: 10px;\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);\n}\n", ""]);

// exports
